import {Component, OnDestroy} from '@angular/core';
import {ActivatedRoute, ActivationEnd, Router} from '@angular/router';
import {filter, first} from 'rxjs/operators';
import {Subscription} from 'rxjs';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.css']
})
export class HeaderComponent implements OnDestroy {

  public isShow: boolean = false;

  public titulo: string;
  public readonly isUsuarioRoute: boolean;
  private titleSubscription: Subscription;

  constructor(activatedRoute: ActivatedRoute, router: Router) {
    this.isUsuarioRoute = activatedRoute.snapshot.url[0].path === 'usuario';
    this.titleSubscription = router.events.pipe(filter(e => e instanceof ActivationEnd)).pipe(first())
      .subscribe((ae: ActivationEnd) => this.titulo = ae.snapshot.data.titulo);
  }

  ngOnDestroy() { this.titleSubscription.unsubscribe(); }

}
